module.exports = __webpack_public_path__ + "img/markerYezzaPink.62c3da82.png";